import ContractualAttendanceStrategy from './ContractualAttendanceStrategy';
import ContractualSplitShiftStrategy from './ContractualSplitShiftStrategy';
import DoctorAttendanceStrategy from './DoctorAttendanceStrategy';
import DoctorSplitShiftStrategy from './DoctorSplitShiftStrategy';
import PoojariAttendanceStrategy from './PoojariAttendanceStrategy';

class AttendanceStrategyFactory {
     static getStrategy(employeeType, splitShift = 'N') {
          console.log('🏭 Factory: Getting strategy for type:', employeeType, 'Split Shift:', splitShift);

          // Normalize employee type and split shift flag
          const normalizedType = employeeType?.toUpperCase().trim();
          const isSplitShift = splitShift?.toUpperCase() === 'Y';

          switch (normalizedType) {
               case 'CONTRACTUAL_EMPLOYEE':
                    if (isSplitShift) {
                         console.log('✅ Using ContractualSplitShiftStrategy');
                         return new ContractualSplitShiftStrategy();
                    }
                    console.log('✅ Using ContractualAttendanceStrategy');
                    return new ContractualAttendanceStrategy();

               case 'DOCTOR':
                    if (isSplitShift) {
                         console.log('✅ Using DoctorSplitShiftStrategy');
                         return new DoctorSplitShiftStrategy();
                    }
                    console.log('✅ Using DoctorAttendanceStrategy');
                    return new DoctorAttendanceStrategy();

               case 'POOJARI':
                    console.log('✅ Using PoojariAttendanceStrategy');
                    return new PoojariAttendanceStrategy();

               default:
                    console.warn(`⚠️ Unknown employee type: ${employeeType}, defaulting to ContractualAttendanceStrategy`);
                    return new ContractualAttendanceStrategy();
          }
     }
}

export default AttendanceStrategyFactory;